import React, { useEffect, useState } from "react";
import { sendJobToCandidateAction } from "../../../redux/action";
import { appSelector } from "../../../../redux/selector";
import { useDispatch, useSelector } from "react-redux";
import { userSelector } from "../../../../user-redux/selector";

const SendJobToCandidateEmail = (props) => {
  const { candidateDetails, jobDetails } = useSelector(appSelector);
  const { user } = useSelector(userSelector);
  const dispatch = useDispatch();

  const { emailData, isSubmitHandler } = props;
  const [htmlTemplate, setHtmlTemplate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  console.log("emailData")
  useEffect(() => {
    const fetchHtmlContent = async () => {
      try {
        const response = await fetch("/emails/sendJobToCandidate2.html");
        let content = await response.text();
        content = await content.replace(
          "{{ jobTitle }}",
          jobDetails?.jobtitle
        );
        content = await content.replace(
          "{{ companyName }}",
          jobDetails?.company_name !== null
            ? jobDetails.company_name
            : "[Confidential]"
        );
        content = await content.replace(
          "{{ description }}",
          emailData?.description
        );
        content = await content.replace(
          "{{ candidateName }}",
          emailData?.candidateName
        );
        setHtmlTemplate(content);
      } catch (error) {
        console.error("Error fetching HTML content:", error);
      }
    };

    fetchHtmlContent();
  }, [emailData]);

  const handleSubmit = () => {
    setIsSubmitting(true);
    let updatedData = {
      candidateid: emailData?.candidateid,
      jobid: emailData?.jobid,
      userid: emailData?.userid,
      status: "1",
    };
    dispatch(
      sendJobToCandidateAction(
        emailData,
        updatedData,
        user?.id,
        candidateDetails?.candidate_id,
        jobDetails?.id
      )
    )
      .then(() => {
        // handleNext();
      })
      .catch((error) => {
        console.error("Error submitting form:", error);
        isSubmitHandler("error");
      })
      .finally(() => {
        setIsSubmitting(false);
        isSubmitHandler("success");
      });
  };

  return (
    <div style={{ height: 500, width: "100%", overflow: "scroll" }}>
      <div dangerouslySetInnerHTML={{ __html: htmlTemplate }} />

      {/* <Box sx={{display:'flex', gap:'10px'}}>
                  <Box sx={{flexGrow:1}} />
                  <Button variant='outlined' size='small' onClick={() => isSubmitHandler('cancel')}>Cancel</Button>
                  <Button variant='contained' size='small' onClick={handleSubmit}>
                  {isSubmitting ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Send Email"
            )}</Button>
                </Box> */}
    </div>
  );
};

export default SendJobToCandidateEmail;
